<template>
<a href="" class="cart" @click.prevent="toggleCart">
  Cart
  <span v-if="count">{{ count }}</span>
</a>
</template>
<script>
export default {
  data: ()=>({
    count: 0,
  }),
  methods: {
    toggleCart() {
      window.appCart.shown=!window.appCart.shown;
    },
    updateCount(newCount) {
      this.count=newCount;
    },
  },
}
</script>

